export const DB_MAX_LOC_SETUP = 100;
export const DB_MAX_TIMESLOT_SETUP = 3000;